import { Component, input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatList } from '@angular/material/list';
import { ViewModelProperty } from '../../models';

import { VMPFormGroupComponent } from '../vmp-form-group/vmp-form-group.component';

@Component({
  selector: 'ldw-settings-form',
  templateUrl: './settings-form.component.html',
  styleUrls: ['./settings-form.component.css'],
  imports: [ReactiveFormsModule, MatList, MatAccordion, VMPFormGroupComponent]
})
export class SettingsFormComponent {
  form: UntypedFormGroup = new UntypedFormGroup({});

  captionWidth = input<number>(230);
  valueWidth = input<number>(600);
  settings = input<Array<Array<ViewModelProperty>>>([]);
}
